import React, { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import { ViralPlaylistsRankedListItem } from '@components/Landing/sections/ViralPlaylists/ViralPlaylistsRankedListItem';
import { LandingRankedList } from '@components/Landing/shared/LandingRankedList';
import { useQuery, ViralPlaylistsDocument } from '@graphql/reactQuery';
import { CLIENT_QUERY_REDUCTION_ON_FRESH_SSR_STRATEGY } from '@utils/constants';

/*#__PURE__*/ gql(/* GraphQL */ `
  query ViralPlaylists {
    currentPlaylistChart {
      id
      chartRanks(pagination: { first: 10, after: null }) {
        edges {
          node {
            ...ViralPlaylistsRankedListItem
          }
        }
      }
    }
  }
`);

export const ViralPlaylists = () => {
  const { data, isInitialLoading } = useQuery(ViralPlaylistsDocument, {
    ...CLIENT_QUERY_REDUCTION_ON_FRESH_SSR_STRATEGY,
  });

  const items = useMemo(
    () =>
      data?.data.currentPlaylistChart.chartRanks.edges.map(({ node }, idx) => (
        <ViralPlaylistsRankedListItem
          key={`viral-playlists-ranked-list-item-${idx}`}
          chartRankFrag={node}
        />
      )),
    [data],
  );

  if (!items?.length && !isInitialLoading) {
    return null;
  }

  return (
    <LandingRankedList
      headingProps={{
        header: 'Viral Playlists',
        pathnameUri: '/charts/viral/playlists',
      }}
      imageRadius="rounded-md"
      isLoading={isInitialLoading}
      numCols={2}
      numRows={5}
      items={items || []}
      id="viral-playlists"
    />
  );
};
